<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-icon large @click="$emit('closed')">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="8">
              <h1 class="text-h5 font-weight-regular pb-4">
                {{ $t("invoices.modificarAnticipoAutomatico") }}
              </h1>
              <p class="py-5">
                {{
                  $t("invoices.introduscaDatosRealizarModificacionDescription")
                }}
              </p>
              <label class="second-type-label"> {{ $t("invoices.nombreEmpresaCliente") }}</label>
              <p class="font-weight-bold">{{ anticipo.nameClient }}</p>
              <label class="second-type-label"> {{ $t("invoices.cuentaAbono") }}</label>
              <v-select
                v-model="form.iban"
                :color="entityConfig.primaryColor"
                :item-color="entityConfig.primaryColor"
                :items="accounts"
                item-text="iban"
                item-value="iban"
                dense
                outlined
                return-object
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="card-action-with-space">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          :color="entityConfig.primaryColor"
          @click="$emit('closed')"
          class="v-btn-width-default"
        >
          {{ $t("accounts.goBack") }}
        </v-btn>
        <v-btn
          depressed
          :disabled="!form.iban"
          :color="entityConfig.primaryColor"
          :style="`color: ${entityConfig.secondaryColor}`"
          @click="confirm"
          class="v-btn-width-default"
        >
          {{ $t("accounts.modify") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "../../Services/index";

export default {
  props: ["visible", "anticipo"],
  data() {
    return {
      entityConfig: "",
      accounts: [],
      form: {
        iban: "",
      },
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.getAccountList();
  },
  methods: {
    confirm() {
      const copy = Object.assign({}, this.anticipo);
      copy.iban = this.form.iban.iban;
      sessionStorage.setItem("editThisAutoAdvance", JSON.stringify(copy));
      this.$router.push("/anticipo-automatico/modificacion/confirmar");
    },
    getAccountList() {
      let userdata = JSON.parse(sessionStorage.getItem("userData"));
      let userId = userdata.supplierId.trim();
      Api.get(`/proveedores/${userId}/cuentas-abono-total`)
        .then((res) => {
          this.accounts = res.data.response;
        })
        .catch((err) => {
          console.error(err);
        })
    },
  },
};
</script>
